<template>
  <div>
    <b-container fluid>
      <b-row class="tab-button-row" v-if="id != 'new'">
        <b-col>
          <router-link :to="{ name: 'contract-detail' }" tag="button" class="btn">Overzicht</router-link>
        </b-col>
        <b-col>
          <router-link :to="{ name: 'contract-detail-edit' }" tag="button" class="btn">Bewerken</router-link>
        </b-col>
      </b-row>

      <b-row v-if="contract == null && this.id != 'new'" class="mt-5">
        <b-col class="text-center">
          <b-spinner label="Spinning"></b-spinner>
        </b-col>
      </b-row>
    </b-container>

    <router-view v-if="contract != null || this.id == 'new'" :contract="contract" v-on:refresh="load" />
  </div>
</template>

<script>
  export default {
    name: 'ContractDetailContainer',
    data () {
      return {
        contract: null,
      }
    },
    props: {
      id: String,
    },
    methods: {
      load () {
        this.contract = null
        if (this.id == 'new') {
          return
        }

        this.$http.get('contracts/'+this.id)
          .then(response => {
            this.contract = response.data
          })
          .catch((error) => {
            console.log(error)
          });
      }
    },
    watch: {
      id () {
        this.load()
      }
    },
    mounted () {
      this.load()
    }
  }
</script>